export default __webpack_public_path__ + "media/zurb/img/legacy/spur/mirror-f2cdfc44092463aad76e818abdb05a07.jpg";